import axios from 'axios';
import { constants } from '../../constants';
import { Chatroom } from '../../models';

export async function patchActivateState(room: Chatroom, activate: boolean) {
  const { id, activity } = room;
  const token = localStorage.getItem('token');
  await axios.patch(
    `${constants.endpoint}/chatrooms/${id}/activate-state`,
    { activityId: activity.id, activate },
    {
      headers: {
        Authorization: `bearer ${token}`,
      },
    }
  );
}
